import {inject, provide, ref} from 'vue'

export const NAVIGATION_CONTEXT_KEY = Symbol('navigationContext')

// provideNavigation
export function provideNavigation () {
  const navigationHeight = ref(44)
  let mediaQueryList = null
  let mediaQueryListener = null

  const updateNavigationHeightCSSVar = () => {
    document.documentElement.style.setProperty(
      '--navigation-height',
      navigationHeight.value + 'px',
    )
  }

  // Setup media query listener for responsive height
  // Set navigation height as CSS variable since
  // Vue's v-bind() in <style> of component is scoped per-file
  if (typeof window !== 'undefined' && window.matchMedia) {
    const mq = window.matchMedia('(min-width: 640px)')

    mediaQueryListener = (event) => {
      navigationHeight.value = event.matches ? 56 : 44
      updateNavigationHeightCSSVar()
    }

    // Set initial value based on current viewport
    navigationHeight.value = mq.matches ? 56 : 44
    mediaQueryList = mq
    updateNavigationHeightCSSVar()

    if (mq.addEventListener) {
      mq.addEventListener('change', mediaQueryListener)
    }
    else if (mq.addListener) {
      mq.addListener(mediaQueryListener)
    }
  }

  // Cleanup function for App.vue to call
  const cleanup = () => {
    if (mediaQueryList && mediaQueryListener) {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener('change', mediaQueryListener)
      }
      else if (mediaQueryList.removeListener) {
        mediaQueryList.removeListener(mediaQueryListener)
      }
      mediaQueryList = null
      mediaQueryListener = null
    }
  }

  const navigationContext = {
    navigationHeight,
    cleanup,
  }

  provide(NAVIGATION_CONTEXT_KEY, navigationContext)

  return navigationContext
}

// useNavigation
export function useNavigation () {
  return inject(NAVIGATION_CONTEXT_KEY, null)
}
